"use client";

import React from "react";
import { ReduxProvider } from "features/provider";
import { ApolloWrapper } from "@/lib/apolloClient";
import { Theme } from "@radix-ui/themes";
import { ToastProvider } from "@/components/ui/toast-provider";
import PendingGeneralAccountWatcher from "@/components/auth/PendingGeneralAccountWatcher";
import { ShoppingListsProvider } from "@/components/shopping-lists/ShoppingListsProvider";
import ServiceWorkerUpdatePrompt from "@/components/ServiceWorkerUpdatePrompt";

import "react-toastify/dist/ReactToastify.css";
import "swiper/swiper-bundle.css";
import "@radix-ui/themes/styles.css";

import { register } from "swiper/element/bundle";
import { LayoutProps } from "types/common";

register();

const AppWrapper: React.FC<LayoutProps & { preloadedState?: any }> = ({
  children,
  preloadedState,
}) => {
  return (
    <ApolloWrapper>
      <ReduxProvider preloadedState={preloadedState}>
        <Theme>
          <ToastProvider>
            <ShoppingListsProvider>
              <PendingGeneralAccountWatcher />
              <ServiceWorkerUpdatePrompt />
              <div className="overflow h-[100%]" key="culineer">
                {children}
              </div>
            </ShoppingListsProvider>
          </ToastProvider>
        </Theme>
      </ReduxProvider>
    </ApolloWrapper>
  );
};

export default AppWrapper;
